import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FilterButton from './FilterButton';
import FilterMenu from './FilterMenu';
import noop from '../../util/noop';

const BaseFilter = props => {
  const { children, active, disabled, isOpen: overrideIsOpen, label,
    onToggleOpen = noop, selected, selectedIcon, selectedIconFamily, isWrapper, dataObjectType, dataAction } = props;

  if (isWrapper) {
    return <>{children}</>;
  }

  let [isOpen, setIsOpen] = useState(false);
  if (typeof overrideIsOpen !== 'undefined') {
    isOpen = overrideIsOpen;
  }
  const toggleOpen = (isOpen) => {
    setIsOpen(isOpen);
    onToggleOpen(isOpen);
  };

  return (
    <div
      className="filter-pill"
      data-object-type={dataObjectType}
      data-action={dataAction}
    >
      <FilterButton
        label={label}
        selected={selected}
        icon={selectedIcon}
        iconFamily={selectedIconFamily}
        disabled={disabled}
        onClick={() => toggleOpen(true)}
        highlighted={active}
      />
      {isOpen && (
        <FilterMenu children={children} />
      )}
      {isOpen && <div
        onClick={() => toggleOpen(false)}
        className="filter-blocker"
      />}
    </div>
  );
}

BaseFilter.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  dataObjectType: PropTypes.string,
  dataAction: PropTypes.string,
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  isWrapper: PropTypes.bool,
  label: PropTypes.string,
  onToggleOpen: PropTypes.func,
  selected: PropTypes.string,
  selectedIcon: PropTypes.string,
  selectedIconFamily: PropTypes.string
};

export default BaseFilter;
